<template>
  <div style="width:100%; height:100%;">
    <el-row>
      <el-col :span="20">
        <el-input v-model="params.title" @keyup.enter.native="basicSearch();" clearable>
          <template slot="prepend">
            <div @click="show = !show" class="search-label">
              高级搜索
              <i :class="show?'el-icon-arrow-down':'el-icon-arrow-right'"></i>
            </div>
          </template>
        </el-input>
      </el-col>
      <el-col :span="4">
        <el-button type="primary" icon="el-icon-search" @click="basicSearch()" style="height: 50px; background-color: #006f6f; border-color: #006f6f;">全站搜索</el-button>
      </el-col>
    </el-row>
      <el-card v-show="show">
        <el-row style="padding-left: 60px">
          <span>省份</span>
          <el-select placeholder="省份" clearable v-model="params.province" @change="selectProvince">
            <el-option v-for="item in ops.provinces" :key="item.value" :value="item.value" :label="item.label"></el-option>
          </el-select>
          <el-divider direction="vertical"></el-divider>
          <span>类型</span>
          <el-select placeholder="类型" clearable v-model="params.coverLvl" @change="selectCoverLvl">
            <el-option v-for="item in ops.coverLvls" :key="item.value" :value="item.value" :label="item.label"></el-option>
          </el-select>
          <el-divider direction="vertical"></el-divider>
          <span>专门性</span>
          <el-select placeholder="专门性" clearable v-model="params.aimLvl" @change="selectAimLvl">
            <el-option v-for="item in ops.aimLvls" :key="item.value" :value="item.value" :label="item.label"></el-option>
          </el-select>
          <p></p>
          <el-button type="warning" size="medium" @click="advancedSearch()"  style="margin-left:32px;background-color: #76be69; border-color: #76be69;">搜索</el-button>
        </el-row>
      </el-card>
  </div>
</template>

<script>
import { provinces, coverLvls, aimLvls } from '@/api/policies'
export default {
  data () {
    return {
      show: false,
      params: {
        province: '',
        coverLvl: '',
        aimLvl: '',
        title: ''
      },
      ops: {
        provinces: [],
        coverLvls: [],
        aimLvls: []
      }
    }
  },
  mounted () {
    provinces({}).then(({data}) => {
      this.ops.provinces = data
    })
    coverLvls({}).then(({data}) => {
      this.ops.coverLvls = data
    })
    aimLvls({}).then(({data}) => {
      this.ops.aimLvls = data
    })
  },
  methods: {
    basicSearch () {
      this.$emit('search', this.params)
    },
    advancedSearch () {
      this.$emit('search', this.params)
    },
    selectProvince (val) {
      if (val !== '') {
        this.params.province = val
      }
    },
    selectCoverLvl (val) {
      if (val !== '') {
        this.params.coverLvl = val
      }
    },
    selectAimLvl (val) {
      if (val !== '') {
        this.params.aimLvl = val
      }
    }
  },
  watch: {
    'params.province' (val) {
      this.params.province = val
      coverLvls(this.params).then(({data}) => {
        this.ops.coverLvls = data
      })
    },
    'params.coverLvl' (val) {
      this.params.coverLvl = val
      provinces(this.params).then(({data}) => {
        this.ops.provinces = data
      })
    },
    'params.aimLvl' (val) {
      this.params.aimLvl = val
      aimLvls(this.params).then(({data}) => {
        this.ops.aimLvls = data
      })
    }
  },
  props: {
    value: {
      type: Object,
      default: () => {}
    }
  }
}
</script>

<style scoped>
.search-label {
  cursor: pointer
}
</style>



// WEBPACK FOOTER //
// src/pages/common/PoliciesSearch.vue